// src/axios.js
import axios from 'axios';

// Configurar axios para incluir el nonce de wp en los headers
/* eslint-disable */
/*if (typeof fbCitaData !== 'undefined' && fbCitaData && fbCitaData.nonce) {
    axios.defaults.headers.common['X-WP-Nonce'] = fbCitaData.nonce;
}*/

// Verificar si el entorno es desarrollo
const hostname = window.location.hostname;
const isDevelopment = hostname === '192.168.4.206'; //Solo muestra los logs en el entorno de desarrollo

const getBaseURL = () => {
    const hostname = window.location.hostname;

    if (hostname === '192.168.4.206') {
        return 'https://intranet.fb.local/api'; // Endpoint para pruebas en local sin WordPress
    } else {
        return `${window.location.origin}/wp-json/fb-cita/v1`; // Endpoint por defecto
    }
};

const instance = axios.create({
    //baseURL: 'https://intranet.fb.local/api', // Endpoint para pruebas en local sin wordpress
    baseURL: getBaseURL(),
    headers: {
        'Content-Type': 'application/json',
    },
    //timeout: 20000,
});

// Interceptor para solicitudes (requests)
instance.interceptors.request.use(
    function(config) {
        if (isDevelopment) {
            console.log('Request:', config);
        }
        return config;
    },
    function(error) {
        if (isDevelopment) {
            console.error('Request Error:', error);
        }
        return Promise.reject(error);
    }
);

// Interceptor para respuestas (responses)
instance.interceptors.response.use(
    function(response) {
        if (isDevelopment) {
            console.log('Response:', response);
        }
        return response;
    },
    function(error) {
        if (isDevelopment) {
            console.error('Response Error:', error);
        }
        return Promise.reject(error);
    }
);

export default instance;